import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { MessageBox } from 'components/MessageBox/MessageBox';
import React, { useEffect, useRef, useState } from 'react';
import { HTTP_METHODS } from 'constants';
import useHttp from 'hooks/useHttp';
import PropTypes from 'prop-types';
import { CANCEL_ABSENCE_URL } from 'api/absence';
import { scrollIntoView } from 'utils/scroll';

const TITLE = 'Cancel absence';
export const AbsenceCancelModal = ({ open, onClose, onSuccess, absenceId }) => {
    const topElementRef = useRef();
    const [messageType, setMessageType] = useState('none');
    const [responseMessage, setResponseMessage] = useState('');
    const {
        data: dataDelete,
        error: errorDelete,
        clearData: clearResponse,
        loading: loadingDelete,
        sendRequest: cancelAbsence,
    } = useHttp();

    useEffect(() => {
        clearResponse();

        if (errorDelete !== null) {
            setResponseMessage(errorDelete.response?.data?.message || 'An error occurred');
            setMessageType('error');
        }

        if (dataDelete) {
            onSuccess('Absence canceled successfully.', 'success');
            onClose();
        }
    }, [errorDelete, dataDelete, messageType]);

    const handleDeleteConfirmation = async () => {
        if (absenceId) {
            await cancelAbsence({
                url: `${CANCEL_ABSENCE_URL}/${absenceId}?status=Canceled`,
                method: HTTP_METHODS.PUT,
            });
        }

        scrollIntoView(topElementRef);
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle style={{ textTransform: 'none' }}>
                {TITLE}
                <Button onClick={onClose} variant="CloseButton">
                    <CloseIcon />
                </Button>
            </DialogTitle>
            <DialogContent>
                <Grid width={500} ref={topElementRef}>
                    {messageType !== 'none' && (
                        <MessageBox messageType={messageType}>{responseMessage}</MessageBox>
                    )}
                    {messageType !== 'success' && (
                        <Grid item xs={5}>
                            <Typography>Are you sure you want to cancel absence?</Typography>
                            <Box mt={2} display="flex" justifyContent="flex-end">
                                <Button
                                    onClick={onClose}
                                    variant="outlined"
                                    sx={{ marginRight: '8px' }}
                                    disabled={loadingDelete}
                                >
                                    No
                                </Button>
                                <Button
                                    onClick={handleDeleteConfirmation}
                                    variant="contained"
                                    color="error"
                                    disabled={loadingDelete}
                                >
                                    Yes
                                </Button>
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

AbsenceCancelModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    absenceId: PropTypes.string.isRequired,
};
